export const homepayprizeConstants = {
  HOME_HOMEPAYPRIZE_REQUEST: 'HOME_HOMEPAYPRIZE_REQUEST',
  HOME_HOMEPAYPRIZE_SUCCESS: 'HOME_HOMEPAYPRIZE_SUCCESS',
  HOME_HOMEPAYPRIZE_FAILURE: 'HOME_HOMEPAYPRIZE_FAILURE',

  SINGLE_HOMEPAYPRIZE_REQUEST: 'SINGLE_HOMEPAYPRIZE_REQUEST',
  SINGLE_HOMEPAYPRIZE_SUCCESS: 'SINGLE_HOMEPAYPRIZE_SUCCESS',
  SINGLE_HOMEPAYPRIZE_FAILURE: 'SINGLE_HOMEPAYPRIZE_FAILURE'
};
